import { useMemo } from 'react';
import RSAA from 'redux-api-middleware/es/RSAA';
import CountryLB from 'root/src/assets/img/flags/LB.png';
import { ROLE } from '@/modules/User';

import CountryAZ from 'root/src/assets/img/flags/AZ.jpg';
import CountryAM from 'root/src/assets/img/flags/AM.png';
import CountryBY from 'root/src/assets/img/flags/BY.jpg';
import CountryBE from 'root/src/assets/img/flags/BE.png';
import CountryBG from 'root/src/assets/img/flags/BG.jpg';
import CountryGB from 'root/src/assets/img/flags/GB.jpg';
import CountryDE from 'root/src/assets/img/flags/DE.png';
import CountryIL from 'root/src/assets/img/flags/IL.png';
import CountryIN from 'root/src/assets/img/flags/IN.png';
import CountryIT from 'root/src/assets/img/flags/IT.png';
import CountryKZ from 'root/src/assets/img/flags/KZ.jpg';
import CountryCY from 'root/src/assets/img/flags/CY.png';
import CountryKG from 'root/src/assets/img/flags/KG.png';
import CountryKR from 'root/src/assets/img/flags/KR.png';
import CountryLT from 'root/src/assets/img/flags/LT.jpg';
import CountryLV from 'root/src/assets/img/flags/LV.png';
import CountryRU from 'root/src/assets/img/flags/RU.png';
import CountryRO from 'root/src/assets/img/flags/RO.jpg';
import CountryUS from 'root/src/assets/img/flags/US.png';
import CountrySA from 'root/src/assets/img/flags/SA.png';
import CountryTJ from 'root/src/assets/img/flags/TJ.png';
import CountryTH from 'root/src/assets/img/flags/TH.png';
import CountryTQ from 'root/src/assets/img/flags/TQ.png';
import CountryUZ from 'root/src/assets/img/flags/UZ.png';
import CountryUA from 'root/src/assets/img/flags/UA.png';
import CountryFR from 'root/src/assets/img/flags/FR.png';
import CountryCH from 'root/src/assets/img/flags/CH.jpg';
import CountrySE from 'root/src/assets/img/flags/SE.jpg';
import CountryEE from 'root/src/assets/img/flags/EE.png';
import CountryCN from 'root/src/assets/img/flags/CN.png';
import CountryTW from 'root/src/assets/img/flags/TW.png';
import CountryCA from 'root/src/assets/img/flags/CA.png';
import CountryMY from 'root/src/assets/img/flags/MY.png';
import CountryHK from 'root/src/assets/img/flags/HK.png';
import CountryVN from 'root/src/assets/img/flags/VN.png';
import CountryPS from 'root/src/assets/img/flags/PS.png';
import CountryEG from 'root/src/assets/img/flags/EG.png';
import CountryJO from 'root/src/assets/img/flags/JO.png';
import CountryIQ from 'root/src/assets/img/flags/IQ.png';
import CountryIR from 'root/src/assets/img/flags/IR.png';
import CountryAE from 'root/src/assets/img/flags/AE.png';
import CountryAU from 'root/src/assets/img/flags/AU.png';
import CountryZA from 'root/src/assets/img/flags/ZA.png';

import { FAILURE, REQUEST, SUCCESS } from '@/modules/Requests';

export const REQUEST_GET_SAMA = 'REQUEST_GET_SAMA';
export const SET_SAMA = 'SET_SAMA';
export const REQUEST_GET_DELEGATES = 'REQUEST_GET_DELEGATES';

const host = process.env.BACKEND_URL;
const initialState = {
  sama: {},
};

const samaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SAMA:
      return {
        ...state,
        [action.meta]: action.payload,
      };
    default:
      return state;
  }
};

export default samaReducer;

export const fetchSama = () => ({
  [RSAA]: {
    endpoint: `${host}/list/sama`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_SAMA,
      },
    })),
  },
});

export const fetchDelegates = id => ({
  [RSAA]: {
    endpoint: `${host}/olimpic/${id}/delegates`,
    method: 'GET',
    types: [REQUEST, SUCCESS, FAILURE].map(type => ({
      type,
      meta: {
        request: REQUEST_GET_DELEGATES,
      },
    })),
  },
});

/* eslint-disable import/prefer-default-export */
export function useCategories(user) {
  const birthYear = new Date(user.birthday).getFullYear();

  return useMemo(
    () =>
      (user.role >= ROLE.ADMIN
        ? settings
        : [
            ...olimpicSettings.filter(
              item =>
                (user.role === ROLE.LEARNER &&
                  item.years.length > 1 &&
                  item.years.indexOf(birthYear) > -1) ||
                (item.years.length === 1 && birthYear <= item.years[0])
            ),
            ...teacherSettings,
          ]
      ).map(item => ({
        label: item.name,
        value: item.name,
      })),
    [user]
  );
}

export const countries = [
  {
    value: 'AZ',
    label: 'country.AZ',
    image: CountryAZ,
  },
  {
    value: 'AM',
    label: 'country.AM',
    image: CountryAM,
  },
  {
    value: 'BE',
    label: 'country.BE',
    image: CountryBE,
  },
  {
    value: 'BY',
    label: 'country.BY',
    image: CountryBY,
  },
  {
    value: 'BG',
    label: 'country.BG',
    image: CountryBG,
  },
  {
    value: 'GB',
    label: 'country.GB',
    image: CountryGB,
  },
  {
    value: 'DE',
    label: 'country.DE',
    image: CountryDE,
  },
  {
    value: 'IL',
    label: 'country.IL',
    image: CountryIL,
  },
  {
    value: 'IN',
    label: 'country.IN',
    image: CountryIN,
  },
  {
    value: 'IT',
    label: 'country.IT',
    image: CountryIT,
  },
  {
    value: 'KZ',
    label: 'country.KZ',
    image: CountryKZ,
  },
  {
    value: 'CY',
    label: 'country.CY',
    image: CountryCY,
  },
  {
    value: 'CN',
    label: 'country.CN',
    image: CountryCN,
  },
  {
    value: 'KG',
    label: 'country.KG',
    image: CountryKG,
  },
  {
    value: 'KR',
    label: 'country.KR',
    image: CountryKR,
  },
  {
    value: 'LB',
    label: 'country.LB',
    image: CountryLB,
  },
  {
    value: 'LT',
    label: 'country.LT',
    image: CountryLT,
  },
  {
    value: 'LV',
    label: 'country.LV',
    image: CountryLV,
  },
  {
    value: 'RU',
    label: 'country.RU',
    image: CountryRU,
  },
  {
    value: 'RO',
    label: 'country.RO',
    image: CountryRO,
  },
  {
    value: 'US',
    label: 'country.US',
    image: CountryUS,
  },
  {
    value: 'SA',
    label: 'country.SA',
    image: CountrySA,
  },
  {
    value: 'TJ',
    label: 'country.TJ',
    image: CountryTJ,
  },
  {
    value: 'TH',
    label: 'country.TH',
    image: CountryTH,
  },
  {
    value: 'TQ',
    label: 'country.TQ',
    image: CountryTQ,
  },
  {
    value: 'UZ',
    label: 'country.UZ',
    image: CountryUZ,
  },
  {
    value: 'UA',
    label: 'country.UA',
    image: CountryUA,
  },
  {
    value: 'FR',
    label: 'country.FR',
    image: CountryFR,
  },
  {
    value: 'CH',
    label: 'country.CH',
    image: CountryCH,
  },
  {
    value: 'SE',
    label: 'country.SE',
    image: CountrySE,
  },
  {
    value: 'EE',
    label: 'country.EE',
    image: CountryEE,
  },
  {
    value: 'TW',
    label: 'country.TW',
    image: CountryTW,
  },
  {
    value: 'CA',
    label: 'country.CA',
    image: CountryCA,
  },
  {
    value: 'MY',
    label: 'country.MY',
    image: CountryMY,
  },
  {
    value: 'HK',
    label: 'country.HK',
    image: CountryHK,
  },
  {
    value: 'VN',
    label: 'country.VN',
    image: CountryVN,
  },
  {
    value: 'PS',
    label: 'country.PS',
    image: CountryPS,
  },
  {
    value: 'EG',
    label: 'country.EG',
    image: CountryEG,
  },
  {
    value: 'JO',
    label: 'country.JO',
    image: CountryJO,
  },
  {
    value: 'IQ',
    label: 'country.IQ',
    image: CountryIQ,
  },
  {
    value: 'IR',
    label: 'country.IR',
    image: CountryIR,
  },
  {
    value: 'AE',
    label: 'country.AE',
    image: CountryAE,
  },
  {
    value: 'AU',
    label: 'country.AU',
    image: CountryAU,
  },
  {
    value: 'ZA',
    label: 'country.ZA',
    image: CountryZA,
  },
].sort((a, b) => {
  if (a.value < b.value) return -1;
  if (a.value > b.value) return 1;
  return 0;
});

const olimpicSettings = [
  {
    name: 'A',
    years: [2023, 2022, 2021, 2020],
    type: 'student',
    level: 31,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'AddC',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'AddD',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'B',
    years: [2018, 2019],
    type: 'student',
    level: 32,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'C',
    years: [2017, 2016],
    type: 'student',
    level: 33,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'D',
    years: [2015, 2014],
    type: 'student',
    level: 34,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'E',
    years: [2013, 2012, 2011, 2010, 2009, 2008],
    type: 'student',
    level: 35,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
];

const teacherSettings = [
  {
    name: "Teacher's A",
    type: 'teacher',
    level: 33,
    params: olimpicSettings[2].params,
  },
  {
    name: "Teacher's B",
    type: 'teacher',
    level: 34,
    params: olimpicSettings[3].params,
  },
];

export const settings = [...olimpicSettings, ...teacherSettings];

export const pamaPrintSettings = [
  {
    name: 'A',
    years: [2023, 2022, 2021, 2020],
    type: 'student',
    level: 25,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION_TABLE',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION_TABLE',
        variant: 'MENTAL', // изначально не было
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
        orientation: 'landscape',
        differentLevel: 36, // кастомный lvl для tie-break печати
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'B',
    years: [2018, 2019],
    type: 'student',
    level: 27,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        printSamples: 30,
        orientation: 'portrait',
        time: 1,
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
        orientation: 'landscape',
        differentLevel: 37, // кастомный lvl для tie-break печати
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'C',
    years: [2017, 2016],
    type: 'student',
    level: 28,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
        orientation: 'landscape',
        differentLevel: 38, // кастомный lvl для tie-break печати
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'D',
    years: [2015, 2014],
    type: 'student',
    level: 10,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        printSamples: 20,
        orientation: 'landscape',
        time: 3,
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        printSamples: 30,
        orientation: 'portrait',
        time: 3,
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        // 5й
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        differentLevel: 28, // из CP 2*1
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        orientation: 'landscape',
        differentLevel: 39, // кастомный lvl для tie-break печати
        time: 1,
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
  {
    name: 'E',
    years: [2013, 2012, 2011, 2010, 2009, 2008],
    type: 'student',
    level: 8,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
        differentLevel: 40, // кастомный lvl для tie-break печати
        orientation: 'landscape',
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },

  {
    name: 'F', // копия C
    years: [],
    type: 'student',
    level: 28,
    params: [
      {
        id: 'AddA',
        type: 'Add',
        title: 'ADD',
        variant: 'ABACUS',
        time: 3,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiA',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionA',
        type: 'Division',
        title: 'DIVISION',
        variant: 'ABACUS',
        time: 3,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'AddB',
        type: 'Add',
        title: 'ADD',
        variant: 'MENTAL',
        time: 1,
        printSamples: 20,
        orientation: 'landscape',
        score: 10,
      },
      {
        id: 'MultiB',
        type: 'Multi',
        title: 'MULTIPLICATION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'DivisionB',
        type: 'Division',
        title: 'DIVISION',
        variant: 'MENTAL',
        time: 1,
        printSamples: 30,
        orientation: 'portrait',
        score: 5,
      },
      {
        id: 'MixA',
        type: 'Mix',
        title: 'TIE',
        variant: 'ABACUS',
        time: 1,
        orientation: 'landscape',
        differentLevel: 38, // кастомный lvl для tie-break печати
      },
      {
        id: 'L',
        type: 'RESULT',
        title: 'RESULT',
      },
    ],
  },
];
